import SocialLogin from './SocialLogin';
export default SocialLogin;
